
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import cutarrow from '@/components/cutarrow.vue';
  import appletcode from "@/components/appletcode.vue"
	import {
		handleClipboard
	} from '@/utils/clipboard'
	import {
		productList,
	} from '@/api/supplier';
  import {
    tempAddOrderQRCodeadd,
    mallgetQrCode,
    tempAddOrderQRCodemodify,
    producttempAddOrderQRCodedetail
  } from "@/api/order"

  import {
    mallsystemTime,
    wxappwxappgenerateurllink
  } from "@/api/user"  
  import {
    productpopoverproductlist
  } from "@/api/supplier"
	import upload from '@/utils/upload/uploadImg.js';
  import {
    dataURLtoFile
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      cutarrow,
      appletcode
    }
  })

  export default class ProductList extends Vue {
    private cutlist = [
      {value:1,label:'选择商品'},
      {value:2,label:'下单二维码预览区'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private choosemsg:any = {}
    private codeloading = false
    private codemsg:any = {}
    private finish = false
    private copytext:any = {
      text:'',
      link:''
    }

    private mounted () {
      this.gettablelist()
    }
    private deliverystatus(event){
      handleClipboard(this.copytext.text+this.copytext.link,event)
    }
    private confirm(){
      if(!this.choosemsg||!this.choosemsg.Id){
        this.$message.error('请选择商品')
        return 
      }
      this.createcode()
    }
    private async createcode(){
      try{
        this.codeloading = true
        let res = await tempAddOrderQRCodeadd({
          ProductId:this.choosemsg.Id
        })
        let ProductTempAddOrderQRCodeId = 0
        if(res.IsSuccess){
          ProductTempAddOrderQRCodeId = res.Result.ProductTempAddOrderQRCodeId
        }
        //获取base64图片
        let res2 = await mallgetQrCode({
          Page:'pages/mall/detail/detail',
          Scene:`id=${this.choosemsg.Id}&codeid=${ProductTempAddOrderQRCodeId}`
        })
        let file = dataURLtoFile(res2.Result)
        //上传图片
        let url = await this.uploading(file)
        
        let res3 = await tempAddOrderQRCodemodify({
          ProductTempAddOrderQRCodeId:ProductTempAddOrderQRCodeId,
          QRCodeUrl:url
        })
        if(res3.IsSuccess){
          this.finish = true
          this.$message.success('操作成功')
          this.codemsg = {
            url:res2.Result,
            title:this.choosemsg.ProductName,
          }

          let time = await producttempAddOrderQRCodedetail({
            Id:ProductTempAddOrderQRCodeId
          })
          let link = await wxappwxappgenerateurllink({
            Path:'pages/mall/detail/detail',
            query:`id=${this.choosemsg.Id}`,
            env_version:location.origin == 'http://testbackend.routuan.com'?'release':'develop'
          })
          this.copytext = {
            text:`【加单链接】${this.choosemsg.ProductName}【链接生成时间：${time.Result.BuildTime}】链接三小时有效，点击下单>> `,
            link:link.Result.url_link
          }
          // console.log(this.codemsg)
          this.gettablelist()
        }

      }finally{
        this.codeloading = false
      }
    }
    private async uploading(file){
      return new Promise((res,rej)=>{
        upload(file,'image',{},[],(suc:any)=>{
          res(suc)
        })
      })
    }
    private changechoose(e,row){
      this.tablelist = this.tablelist.map(v=>{
        v.ischoose = false
        if(v.Id==row.Id){
          v.ischoose = true
          this.choosemsg = v
        }
        return v
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist() {
			try {
        this.tableloading = true
				let params:any = {
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					Keywords: this.keywords,
          ProductScheduleState:1,
				}
				const res: any = await productpopoverproductlist(params);
				this.total = res.Result.Total;
				this.tablelist = res.Result.Results.map(v=>{
          if(res.Result.Results.length==1){
            v.ischoose = true
            this.choosemsg = v
          }else{
            v.ischoose = this.choosemsg.Id==v.Id
          }
          return v
        })
        
			} finally{
        this.tableloading = false
      }
		}
  }
